import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'

import { useApi } from 'api'
import { Invoice } from 'types'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import InvoiceDetails from './InvoiceDetails'

const InvoiceShow = () => {
  const navigation = useNavigate()
  const { id } = useParams<{ id: string }>()
  const api = useApi()
  const [invoice, setInvoice] = useState<Invoice>()

  useEffect(() => {
    api
      .getInvoice(id)
      .then(({ data }) => {
        setInvoice(data)
      })
      .catch(() => {
        navigation('/')
      })
  }, [api, id, navigation])

  return (
    <>
      <Link to="/">
        <Button variant="outline-secondary">&lt; Back to the list</Button>
      </Link>
      {invoice && <InvoiceDetails invoice={invoice}></InvoiceDetails>}
    </>
  )
}

export default InvoiceShow
